import { Component, inject, input } from '@angular/core';
import { TrackLinkDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { DOCUMENT } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'wl-skip-link',
  standalone: true,
  templateUrl: './skip-link.component.html',
  styleUrls: [
    './skip-link.component.essent.scss',
    './skip-link.component.ed.scss',
  ],
  imports: [TrackLinkDirective, AutomationIdDirective, RouterLink],
})
export class SkipLinkComponent {
  readonly loginUrl = input.required<string>();
  readonly disableSkipToLogin = input<boolean>(false);

  readonly #document = inject(DOCUMENT);

  setFocusOnMainContent() {
    this.#document.getElementById('main-content')?.focus();
  }
}
